import React from 'react'
import { STATUS_SCHEDULED } from '@disco/constants/CampaignTypes'
import CampaignListPage from 'pages/campaigns/campaign-list'

const ScheduledCampaignListPage = (): React.ReactNode => {
  return <CampaignListPage fullPage={STATUS_SCHEDULED} />
}

export default ScheduledCampaignListPage
